import { Component, OnInit } from "@angular/core";

@Component({
    selector: "ngx-demo-apply",
    template: `<ngx-one-column-layout>
        <router-outlet></router-outlet>
    </ngx-one-column-layout>`,
    styleUrls: ["./demo-apply.component.scss"],
})
export class DemoApplyLayoutComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
